module.exports = __webpack_public_path__ + "static/red_hat_white-bf6f36f9679fb8c18a870d6ff18038ff.png";